import React, { useState, useEffect } from "react";
import LogoHeader from "./LogoHeader";
import LogoFooter from "./LogoFooter";
import ErrorContainer from "../controls/ErrorContainer";
import getSettings from "../helpers/getSettings";

const FIMUserDeactivated = props => {

    const [settings, setSettings] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        getSettings('eScreen123', setSettings, setError, 'Unable to retrieve settings!');
    }, []);

    return (
        <form id={"fudForm"}>
            <div className="modal-content">
                <LogoHeader clientName="eScreen123" />
                <ErrorContainer errorDescription={error} />
                <div className="stackLabel">
                    <div>
                        <div className="stackLabelContent">
                            <p className="bold">User account is inactive.</p>
                            <p>Please contact your administrator.</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <button id={"fudButtonReturn"} type="button" className="button full-width" onClick={() => window.location.href = settings?.identityServerLoginUrl}>
                            Return to Login
                        </button>
                    </div>
                </div>
                <div>
                    <LogoFooter />
                </div>
            </div>
        </form>
    );
};

export default FIMUserDeactivated;
